import { useCallback, memo } from 'react';
import { useFormattedCurrencyDisplay } from '../v2/hooks/useFormattedCurrencyDisplay';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import NumberInputAdapter from '../adapters/NumberInput';
import CurrencyInputAdapter from '../adapters/CurrencyInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHomeCurrencyV2 = props => {
  const {
    onChange,
    inputRef,
    multiCurrencyCurrencyCode,
    min: minFromProps
  } = props;
  useComponentMountMetric('PropertyInputHomeCurrencyV2');
  const {
    currencyValue,
    currencyCode,
    formattingOptions: {
      min,
      fractionalCurrencyProps
    }
  } = useFormattedCurrencyDisplay({
    defaultCurrencyCode: multiCurrencyCurrencyCode,
    defaultMin: minFromProps
  });
  const handleChange = useCallback(evt => {
    if (typeof onChange === 'function') {
      // UINumberInput and UICurrencyInput's onChange send `number | null`; convert to `string | null`
      onChange(evt.target.value == null ? evt : syntheticEvent(String(evt.target.value)));
    }
  }, [onChange]);
  return !currencyCode ? /*#__PURE__*/_jsx(NumberInputAdapter, Object.assign({}, getTransferrableProps(props), {
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UINumberInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  })) : /*#__PURE__*/_jsx(CurrencyInputAdapter, Object.assign({}, getTransferrableProps(props), fractionalCurrencyProps, {
    isNativeCurrency: false,
    currency: currencyCode,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UICurrencyInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue,
    min: min
  }));
};
export default /*#__PURE__*/memo(PropertyInputHomeCurrencyV2);